// extracted by mini-css-extract-plugin
module.exports = {"portfolio":"projects-module--portfolio--19qA8","projects":"projects-module--projects--2ynd9"};